import DeleteIcon from "@mui/icons-material/CloseSharp";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const SubmitReviewalPopup = (props) => {
  const dispatch = useDispatch();
  const { accessToken } = useSelector((state) => state.user);
  const [reviewerEmailOptions, setReviewerEmailOptions] = useState([]);
  const [stageOptions, setStageOptions] = useState([]);
  const [submitReviewalDataErrors, setErrors] = useState({
    design_stages: "",
    reviewer_name: "",
    reviewer_email: "",
  });

  const { loading, targetScenario, error, success } = useSelector(
    (state) => state.targetScenario
  );

  const {
    title,
    openPopup,
    setClosePopup,
    material,
    successCallbackFn,
    targetSelection,
    regionLooker
  } = props;
  const [targetOption, setTargetOption] = useState(targetSelection);
  const [targetValue, setTargetValue] = useState(0);
  const { finalWorkspaceData } = useSelector((state) => state.workspaceData);
  const [submitReviewalData, setSubmitReviewalData] = useState({
    design_stages: "",
    reviewer_name: "",
    reviewer_email: "",
  });

  useEffect(() => {
    targetScenario.length !== 0 &&
      setTargetOption(targetScenario.target_scenario_selection);
    targetScenario.length !== 0 &&
      setTargetValue(
        targetScenario.target_scenario[targetScenario.target_scenario_selection]
      );
  }, [openPopup, targetScenario]);

  useEffect(() => {
    targetScenario.length !== 0 &&
      setTargetValue(targetScenario.target_scenario[targetOption]);
  }, [targetOption]);

  useEffect(() => {
    setSubmitReviewalData({
      design_stages: "",
      reviewer_name: "",
      reviewer_email: "",
    });

    setErrors({
      design_stages: "",
      reviewer_name: "",
      reviewer_email: "",
    });

    if (Array.isArray(targetScenario)) {
      if (targetScenario.length === 0) {
        return;
      }
    }

    if (targetScenario && targetScenario.design_stages.length > 0) {
      setStageOptions(targetScenario.design_stages);
    }

    if (targetScenario && targetScenario.reviewers_list.length > 0) {
      const reviewerEmails = targetScenario.reviewers_list.map((value) => ({
        label: value.user_email_id,
        id: value.user_email_id,
      }));
      setReviewerEmailOptions(reviewerEmails);
    }
  }, [targetScenario]);

  const submitReviewal = () => {
    // Perform validation
    const validationErrors = {};
    // Validate design stages
    if (submitReviewalData.design_stages == "") {
      setErrors({
        ...submitReviewalDataErrors,
        design_stages: "Please select a design stage.",
      });
      return;
    } else {
      setErrors({ ...submitReviewalDataErrors, design_stages: "" });
    }

    if (!submitReviewalData.reviewer_name) {
      setErrors({
        ...submitReviewalDataErrors,
        reviewer_name: "Please enter the reviewer's name.",
      });
      return;
    } else {
      setErrors({ ...submitReviewalDataErrors, reviewer_name: "" });
    }

    if (!submitReviewalData.reviewer_email) {
      setErrors({
        ...submitReviewalDataErrors,
        reviewer_email: "Please enter the reviewer's email.",
      });
      return;
    } else {
      setErrors({ ...submitReviewalDataErrors, reviewer_email: "" });
    }

    if (Object.keys(validationErrors).length === 0) {
      successCallbackFn(
        targetOption == "" ? targetSelection : targetOption,
        submitReviewalData
      );
    }
  };

  return (
    <Dialog className="custom-popup submit-popup" open={openPopup}>
      <DialogTitle className="custom-header">
        <span className="title">
          {title}
          {material && <div>-{material}</div>}
        </span>
        <IconButton onClick={setClosePopup} aria-label="Close">
          <DeleteIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Box component="form" className="custom-form">
            <Box className="form-field">
              <p className="help-text">
                The assessment will pass through two reviewers, please input the
                first reviewer’s details below. You will be notified once the
                assessment has been approved or denied by the first and second
                reviewer.{" "}
              </p>
            </Box>
            <Box className="form-field">
              <label>Target Scenario</label>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                className="target-radio"
                defaultValue={targetSelection}
                // value={targetOption}
                onChange={(event) => setTargetOption(event.target.value)}
              >
                <FormControlLabel
                  value="Base"
                  control={<Radio />}
                  label="Base"
                />
                <FormControlLabel
                  value="Moderate"
                  control={<Radio />}
                  label="Moderate"
                />
                <FormControlLabel
                  value="Stretch"
                  control={<Radio />}
                  label="Stretch"
                />
                <FormControlLabel
                  value="Innovation"
                  control={<Radio />}
                  label="Innovative"
                />
              </RadioGroup>
              <Box className="target-value">
                <Box>
                  {targetValue}
                  <span>kgCO2-eq/{regionLooker === "United States" ? "ft2" : "m2"}</span>
                </Box>
              </Box>
            </Box>
            <Box className="form-field">
              <InputLabel required shrink={false}>
                What design stage is this assessment in?
              </InputLabel>
              <Select
                {...(submitReviewalDataErrors.design_stages !== "" && {
                  error: true,
                })}
                displayEmpty
                fullWidth
                placeholder="Select the stage"
                defaultValue={submitReviewalData.design_stages}
                value={submitReviewalData.design_stages}
                onChange={(event) => {
                  setSubmitReviewalData({
                    ...submitReviewalData,
                    design_stages: event.target.value,
                  });
                  if (event.target.value !== "") {
                    setErrors({
                      ...submitReviewalDataErrors,
                      design_stages: "",
                    });
                  } else {
                    setErrors({
                      ...submitReviewalDataErrors,
                      design_stages: "Please select the stage.",
                    });
                  }
                }}
              >
                <MenuItem value="" disabled>
                  <Box>Select the stage</Box>
                </MenuItem>
                {stageOptions.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText className="error">
                {submitReviewalDataErrors.design_stages}
              </FormHelperText>
            </Box>
            <Box className="form-field">
              <InputLabel required>Reviewer Name</InputLabel>
              <TextField
                fullWidth
                type="text"
                {...(submitReviewalDataErrors.reviewer_name !== "" && {
                  error: true,
                })}
                helperText={submitReviewalDataErrors.reviewer_name}
                onChange={(event) => {
                  const reviewerName = event.target.value;
                  setSubmitReviewalData({
                    ...submitReviewalData,
                    reviewer_name: reviewerName,
                  });
                  if (event.target.value !== "") {
                    setErrors({
                      ...submitReviewalDataErrors,
                      reviewer_name: "",
                    });
                  } else {
                    setErrors({
                      ...submitReviewalDataErrors,
                      reviewer_name: "Please enter the reviewer's name.",
                    });
                  }
                }}
                placeholder="Input name here"
              />
            </Box>
            <Box className="form-field">
              <InputLabel required>Reviewer Email</InputLabel>

              <Autocomplete
                disablePortal
                fullWidth
                id="combo-box-demo"
                options={reviewerEmailOptions}
                {...(submitReviewalDataErrors.reviewer_email !== "" && {
                  className: "input-error",
                })}
                isOptionEqualToValue={(option, value) => option.label === value}
                onChange={(event, option) => {
                  setSubmitReviewalData({
                    ...submitReviewalData,
                    reviewer_email: option?.id || "",
                  });
                  if (option?.id !== "") {
                    setErrors({
                      ...submitReviewalDataErrors,
                      reviewer_email: "",
                    });
                  } else {
                    setErrors({
                      ...submitReviewalDataErrors,
                      reviewer_email: "Please select a reviewer email.",
                    });
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    placeholder="Select Reviewer Name"
                  />
                )}
              />
              <FormHelperText className="error">
                {submitReviewalDataErrors.reviewer_email}
              </FormHelperText>
            </Box>
            <Box className="custom-footer">
              <Button
                variant="outlined"
                className="btn-primary"
                onClick={setClosePopup}
              >
                Back
              </Button>
              <Button
                className="btn-secondary"
                variant="contained"
                onClick={submitReviewal}
              >
                Submit for reviewal
              </Button>
            </Box>
          </Box>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default SubmitReviewalPopup;
